const Experiments = {
  LoadWithImportAMDModule: 'specs.wixCode.LoadWithImportAMDModule',
  ResolveMissingPlatformNamespaces:
    'specs.wixCode.resolveMissingPlatformNamespaces',
  UsePublicConfigEndpoint: 'specs.wixCode.usePublicConfigEndpoint',
};

module.exports.Experiments = Experiments;
